import { useIsPen4604Enabled } from './useIsPen4604Enabled'

const QUIZ_RESULTS_LOCATION = 'quiz-results-carousel'

export const useShouldShowPen4604Experiment = (location: string) =>
  useIsPen4604Enabled() && location === QUIZ_RESULTS_LOCATION
